// extracted by mini-css-extract-plugin
module.exports = {"text":"NoCaseNoteDetail_text__2p_ck","button":"NoCaseNoteDetail_button__2RY5e","icon":"NoCaseNoteDetail_icon__3lBxJ"};